App.directive('backStep', ['$window', 'Config', function ($window, Config) {
    return {
        restrict: 'AEC',
        scope: {
            linkStep: '=',
            nameStep: '='
        },
        templateUrl: Config.TEMPLATES_DIR + 'back-step.html'
    };
}]);